export const ROUTES = {
  HOME: '/',
  LOGIN: {
    BASE: 'login',
  },
  MODULE: {
    BASE: '/Module/:id/*',
    TASK: {
      BASE: 'Task',
      LINK: '/Module/Task',
    },
  },

  // FORM KHẢO SÁT
  SURVEY_TABLE: {
    BASE: 'SurveyTable/*',
    LINK: '/SurveyTable',
    ADD: 'SurveyTable/add/*',
    EDIT: {
      BASE: 'SurveyTable/:id',
      LINK: '/SurveyTable/'
    },
    SURVEY_REPORT: {
      BASE: 'SurveyReport',
      LINK: '/SurveyReport',
    },
    FEEDBACK: {
      BASE: 'Feedback/:nameId',
      LINK: '/Feedback/',
    }
  },
  CUSTOMER_INFO: {
    BASE: '/Form/*',
    CUSTOMER: {
      BASE: 'Customer/*',
      LINK: '/Form/Customer',
      DETAIL: 'Profile',
    },
  },
  CUSTOMER: {
    BASE: '/Customer/*',
    APPOINTMENT: {
      BASE: 'Appointment/*'
    },
    // Phân khúc khách hàng
    CUSTOMER_SEGMENTATION: {
      BASE: 'CustomerSegmentation/*',
      LINK: '/Customer/CustomerSegmentation',
      DETAIL: {
        BASE: 'CustomerSegmentation/detail',
        LINK: '/Customer/CustomerSegmentation/detail'
      }
    },
    CONTACT_SEGMENTATION: {
      BASE: 'ContactSegmentation/*',
      LINK: '/Customer/ContactSegmentation',
      DETAIL: {
        BASE: 'ContactSegmentation/Create',
        LINK: '/Customer/ContactSegmentation/Create'
      }
    },
    // Khách hàng chưa định danh
    CUSTOMER_UNIDENTIFIED: {
      BASE: 'CustomerUnidentified/*',
      LINK: '/Customer/CustomerUnidentified',
      DETAIL: {
        BASE: 'CustomerUnidentified/detail/*',
        LINK: '/Customer/CustomerUnidentified/detail'
      }
    }
  },

  // CHIẾN DỊCH / CAMPAIGN
  CAMPAIGN: {
    BASE: 'Campaign/*',
    // QUẢN LÝ NỘI DUNG
    CONTENT_MANAGE: {
      BASE: 'Content/*',
      LINK: '/Campaign/Content',
      DETAIL: {
        BASE: 'Content/detail',
        LINK: '/Campaign/Content/detail?contentId=',

      },
      CREATE: {
        BASE: 'Content/create',
        LINK: '/Campaign/Content/create',
      },
    },
    // QUẢN CHIẾN DỊCH
    CAMPAIGN_MANAGE: {
      BASE: 'CampaignList/*',
      LINK: '/Campaign/CampaignList',

      DETAIL: {
        BASE: 'CampaignList/detail',
        LINK: '/Campaign/CampaignList/detail?campaignId='
      },
      CREATE: {
        BASE: 'CampaignList/create',
        LINK: '/Campaign/CampaignList/create'
      }
    },
  },

  EXCHANGE_REWARDS: {
    BASE: 'ExchangeRewards/*',
    GIFTS: {
      BASE: 'Gifts/*',
      LINK: '/ExchangeRewards/Gifts',
      DETAIL: 'Gifts/Edit/:id',
      CREATE: {
        BASE: 'Gifts/create',
        LINK: '/ExchangeRewards/Gifts/create',
      },
    },
    MANAGE: {
      BASE: 'Manage/*',
      LINK: '/ExchangeRewards/Manage',
      DETAIL: 'Manage/Edit/:id',
      CREATE: {
        BASE: 'Manage/create/*',
        LINK: '/ExchangeRewards/Manage/create',
        REWARD: {
          BASE: 'Manage/create/reward/:customerId/:programId',
          LINK: '/ExchangeRewards/Manage/create/rewards',
        }
      },
    }
  },

  ICONS: {
    BASE: '/Icons',
  },
  ZALO_ZNS: {
    BASE: 'ZNS/*',
    // Danh sách ZNS
    LIST_ZNS: {
      BASE: 'Manage/*',
      LINK: '/ZNS/Manage',
      DETAIL: '/ZNS/Manage/Detail/:id'
    },
    // Nghiệp vụ sử dụng ZNS
    ZALO_TASK_ZNS: {
      BASE: 'ZaloTask/*',
      LINK: '/ZNS/ZaloTask',
      EDIT: 'Edit'
    },
    // Báo cáo kết quả gửi ZNS
    REPORT_ZNS: {
      BASE: 'Report/*',
      LINK: '/ZNS/Report'
    },
    // Danh sách ZNS
    CONNECT_ZALO: {
      BASE: 'Connect/*',
    },
  },
  REMINDERS: {
    BASE: 'Reminder/*',
    // lịch nhắc nhở
    REMINDLIST: {
      BASE: 'RemindList/*',
      LINK: '/Reminder/RemindList'
    },
    // nhắc nhở báo cáo
    REMINDTYPE: {
      BASE: 'Warranty/*',
      LINK: '/Reminder/Warranty'
    },
    // Cấu hình thời gian nhắc nhở bảo hành
    SETUP_TIME: {
      BASE: 'SetUpTimeWarranty/*',
      LINK: '/Reminder/SetUpTimeWarranty'
    },
  },
  // Dư liệu nền
  MASTER_DATA: {
    BASE: '/MasterData/*',
    // Công ty
    COMPANY: {
      BASE: 'Company/*',
      CREATE: 'Create',
      EDIT: 'Edit/:id',
    },
    // Chi nhánh
    BRANCH: {
      BASE: 'Store/*',
      CREATE: 'Create',
      EDIT: 'Edit/:id',
    },
    // Phòng ban
    DEPARTMENT: {
      BASE: 'Department/*',
      CREATE: 'Create',
      EDIT: 'Edit/:id',
    },

    // NHẮC NHỞ THỜI GIAN BẢO HÀNH
    WARRANTY_REMINDER: {
      BASE: 'SetWarrantyReminder/*',
      LINK: '/MasterData/SetWarrantyReminder',
      CREATE: {
        BASE: 'SetWarrantyReminder/Create',
        LINK: '/MasterData/SetWarrantyReminder/Create',
      },
      DETAIL: {
        BASE: 'SetWarrantyReminder/detail/',
        LINK: '/MasterData/SetWarrantyReminder/detail?contentId=',
      },
    },


    // bỏ theo dõi nhắc nhở bảo hành
    UNFOLLOW_REMIND: {
      BASE: 'UnfollowRemind/*',
      LINK: '/MasterData/UnfollowRemind',
      CREATE: {
        BASE: 'UnfollowRemind/Create',
        LINK: '/MasterData/UnfollowRemind/Create',
      },
    },

    WARRANTY_TIME_REMIND: {
      BASE: 'WarrantyTimeRemind/*',
      LINK: '/MasterData/WarrantyTimeRemind',
    }
  },

  // Quản lý dự án
  PROJECT_MANAGEMENT: {
    BASE: 'Project/*',
    // Báo cáo chi tiết dự án
    REPORT_DETAIL: {
      BASE: 'BaoCaoChiTietDuAn/*',
      LINK: '/Project/BaoCaoChiTietDuAn'
    },
  },
  // chiến dịch event
  EVENT_CAMPAIGN: {
    BASE: 'Event/*',
    // Báo chi tiết chiến dịch Event
    REPORT_DETAIL: {
      BASE: 'EventCampaignReport/*',
      LINK: '/Event/EventCampaignReport'
    },
  },
  // chiến dịch Marketing
  MARKETING_CAMPAIGN: {
    BASE: 'MarketingCampaign/*',
    // BÁO CÁO DANH SÁCH TÀI TRỢ-QUÀ TẶNG KHÁCH HÀNG
    PRESENT_REPORT: {
      BASE: 'BaoCaoTaiTroQuaTang/*',
      LINK: '/MarketingCampaign/BaoCaoTaiTroQuaTang'
    },
    // BÁO CÁO TỔNG HỢP TÀI TRỢ KHÁCH HÀNG
    THTTKH_REPORT: {
      BASE: 'BCTongHopTaiTroKH/*',
      LINK: '/MarketingCampaign/BCTongHopTaiTroKH'
    },
  },
  // Báo cáo bảo hành - khiếu nại
  WARRANTY_COMPLAINT: {
    BASE: 'Complaint/*',
    // Báo cáo Tổng hợp xử lý khiếu nại 3 miền
    BC_TH_3_MIEN: {
      BASE: 'TongHopXLKN3Mien/*',
      LINK: '/Complaint/TongHopXLKN3Mien'
    },
    // Báo cáo So sánh XLKN 3 miền
    BC_SS_3_MIEN: {
      BASE: 'SoSanhXLKN3Mien/*',
      LINK: '/Complaint/SoSanhXLKN3Mien'
    },
  },
  // Báo cáo bảo hành - khiếu nại
  REPORT_VISIT_CUSTOMER: {
    BASE: 'Reports/*',
    // báo cáo chi tiết đánh giá của khách hàng ghé thăm sr
    BC_DETAIL_VISIT_CUSTOMER: {
      BASE: 'RateDetailOfCustomer/*',
      LINK: '/Reports/RateDetailOfCustomer'
    },
    // báo cáo tổng hợp đánh giá của khách hàng ghé thăm sr
    BC_GENERAL_VISIT_CUSTOMER: {
      BASE: 'GeneralRateOfVisitCustomer/*',
      LINK: '/Reports/GeneralRateOfVisitCustomer'
    },
    // báo cáo tỷ lệ đánh giá trên tổng số lượt ghé thăm
    BC_RATIO_RATE: {
      BASE: 'RateOfNumberVisit/*',
      LINK: '/Reports/RateOfNumberVisit'
    },
    // báo cáo điểm đánh giá trung bình theo thời gian
    BC_EVERAGE_RATING: {
      BASE: 'RatePointAverageOfTime/*',
      LINK: '/Reports/RatePointAverageOfTime'
    },
    // báo cáo điểm đánh giá trung bình theo thời gian
    BC_RATING_UNSATISFIED: {
      BASE: 'RateUnsatisfied/*',
      LINK: '/Reports/RateUnsatisfied'
    },
    // Báo cáo kích hoạt bảo hành
    BC_WARRANTY_ACTIVE: {
      BASE: 'WarrantyActiveReport/*',
      LINK: '/Reports/WarrantyActiveReport'
    },
    // Báo cáo khảo sát ý kiến của khách hàng
    BC_CUSTOMER_SURVEY: {
      BASE: 'CustomerSurvey/*',
      LINK: '/Reports/CustomerSurvey'
    },
    // Báo cáo trạng thái công việc
    BC_WORK_STATUS: {
      BASE: 'WorkStatus/*',
      LINK: '/Reports/WorkStatus'
    },
    // Báo cáo thông kê số liệu lịch
    BC_STATISTICS_REVENUE: {
      BASE: 'StatisticRevenue/*',
      LINK: '/Reports/StatisticRevenue'
    },
    // Báo cáo thông kê trạm bảo hành
    BC_STATISTICS_WARRANTY: {
      BASE: 'StatisticWarranty/*',
      LINK: '/Reports/StatisticWarranty'
    },
    // Báo cáo thông kê trạm bảo hành
    BC_CUSTOMER_GENERAL: {
      BASE: 'ProfileReport2/*',
      LINK: '/Reports/ProfileReport2'
    }
  },

  // TIỆN ÍCH
  UTILITIES: {
    BASE: 'Work/*',
    // Kho tài liệu
    ARCHIVES: {
      BASE: 'Archives/*',
      LINK: '/Work/Archives',
      ADD: 'Archives/Add',
      EDIT: 'Archives/Edit/:id'
    },
  }
};
